<template>
    <div class="modal-card view-contact-modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Company Contacts</p>
        </header>
        <section class="modal-card-body">
            <contacts :reference-id="companyId" reference-type="company" :is-modal="true"/>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Contacts from './../../pages/companies/show/Contacts'

    export default {
        props: ['companyId'],

        components: {
            Contacts
        }
    }
</script>

<style scoped>
    .modal-card {
        width: 100%;
    }
</style>
